module.exports = __webpack_public_path__ + "static/media/Slider2_funktioniert-natuerlich.7014ad2e.jpg";